// extracted by mini-css-extract-plugin
export default {"cardImage":"lib-component-mappings-sky-parallax-components-ProductHeroCTAs-CardImage__cardImage--FFaf3"};